import React from "react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Settings, Package, Globe2, Newspaper, Images, MessageSquareQuote, Users, Handshake, Inbox, LogOut, KeyRound, ExternalLink } from "lucide-react";
import { useAdminAuth } from "./AdminAuth";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/inquiries", label: "Inquiries", icon: Inbox },
  { to: "/admin/settings", label: "Site Settings", icon: Settings },
  { to: "/admin/c/packages", label: "Packages", icon: Package },
  { to: "/admin/c/tours", label: "Halal Tours", icon: Globe2 },
  { to: "/admin/c/blogs", label: "Blog Posts", icon: Newspaper },
  { to: "/admin/c/gallery", label: "Gallery", icon: Images },
  { to: "/admin/c/testimonials", label: "Testimonials", icon: MessageSquareQuote },
  { to: "/admin/c/team", label: "Scholars & Team", icon: Users },
  { to: "/admin/c/partners", label: "Partners", icon: Handshake },
  { to: "/admin/account", label: "Account", icon: KeyRound },
];

const AdminLayout = () => {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><div className="w-10 h-10 rounded-full border-4 border-jannah-sand border-t-jannah-green animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-jannah-cream flex" data-testid="admin-layout">
      <aside className="w-64 shrink-0 bg-jannah-green-dark text-white flex flex-col sticky top-0 h-screen">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="bg-white rounded-lg px-3 py-2 inline-block"><img src="/logo.png" alt="Fly Jannah" className="h-10" /></div>
          <div className="mt-3 text-xs uppercase tracking-widest text-jannah-gold-light">Admin Panel</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.to.split("/").pop() || "dashboard"}`} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-jannah-gold text-white" : "text-white/75 hover:bg-white/10 hover:text-white"}`}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-xs text-white/70 hover:text-white"><ExternalLink size={14} /> View website</a>
          <div className="text-xs text-white/50 truncate">{user.email}</div>
          <button onClick={() => { logout(); navigate("/admin/login"); }} className="flex items-center gap-2 text-sm text-white/80 hover:text-jannah-gold-light" data-testid="admin-logout-btn"><LogOut size={15} /> Logout</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 md:p-10"><Outlet /></main>
    </div>
  );
};

export default AdminLayout;
